<template>
  <div class="sp-company-certification-form">
    <CompanySPUploadCertificationsForm @onCertificationDataChanged="onCertificationDataChanged"/>
    <CompanySPAddLinkedinLink :value="socialMediaNetworkValue" @onLinkedInLinkChanged="onLinkedInLinkChanged"/>
    <SPCompanyIPWhitelistForm :value="ipList" @onIpChange="onIpChange"/>
  </div>
</template>

<script>
import SPCompanyIPWhitelistForm from '@/components/spCompanyRegistration/AddIpsForWhitelist.vue';
import CompanySPUploadCertificationsForm from '@/components/spCompanyRegistration/CompanySPUploadCertificationsForm.vue';
import CompanySPAddLinkedinLink from '@/components/spCompanyRegistration/CompanySPAddLinkedinLink.vue';

export default {
  name: 'CompanySPCertificationForm',
  components: {
    CompanySPAddLinkedinLink,
    CompanySPUploadCertificationsForm,
    SPCompanyIPWhitelistForm,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    socialMediaNetworkValue: {
      type: Object,
      required: true,
    },
    ipList: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCertificationDataChanged(data) {
      this.$emit('onCertificationDataChanged', data);
    },
    async onIpChange(data) {
      await this.$emit('onIpChange', data);
    },
    async onLinkedInLinkChanged(data) {
      await this.$emit('onLinkedInLinkChanged', data);
    },
  },
};
</script>

<style>

</style>
